export enum Reports {
  ImpactTest = "ImpactTest",
  Shingle = "Shingle",
  Siding = "Siding",
}
